<script setup>
  import { usePuzzleStore } from '@/stores/puzzleStore';
  const puzzleStore = usePuzzleStore();
</script>


<template>
    <nav class="navbar-container d-flex align-items-center justify-content-between pt-3 pb-3">
      <span class="nav-item left search m-0" @click="$router.push({ name: 'search' })">&lt; NEW SEARCH</span>
      <span v-if="puzzleStore.showAnalysis" class="nav-item right analysis m-0" @click="$router.push({ name: 'analysis' })">ANALYSIS &gt;</span>
    </nav>
</template>
  
<style scoped>


  /* Navbar Container */
  .navbar-container {
    background: transparent; 
    font-size: 2rem;
    font-family: 'Oswald'; 
  }

 .search {
    color: #ebecd0; 
  }

 .analysis {
    color: #ebecd0; 
  }

  
  /* Navbar Items */
  .nav-item {
    cursor: pointer;
    transition: color 0.2s ease-in-out;
  }
  
  .nav-item:hover {
    color: #fff; 
  }
</style>